export class AuthToken {
  constructor(public token: string, public expiry: Date) {}

  public isExpiringSoon() {
    const currentTimestamp = Date.now(); // Current UTC timestamp in milliseconds
    const expiryTimestamp = new Date(this.expiry).getTime(); // Convert the given timestamp to milliseconds
    // Calculate the difference in milliseconds between the current time and the expiry time
    const timeDifference = expiryTimestamp - currentTimestamp;

    // Check if the time difference is less than or equal to 5 minutes (300,000 milliseconds)
    return timeDifference <= 300000;
  }
}
